module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAARVBMVEUAAADxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfxmKfS0ALzAAAAFnRSTlMAIqot3x53C6KOMwPuw5c5G9Z7W0EXZepepAAAAH9JREFUKM+dzkkSwjAMRNF2LOMpkDDp/keFIpScWNYmf/uqpMZCPIwWEBvdwZzdoMz8JY9B/k8xTYdSFArcFX5ENjkyCW41CThJkUyCI4PENGl77wnRtVY00r0OVPPUmnkWUP9u6I0uW8+K3q6QehPSlmAWQynFV+PmNs+yB4APbOkY0YxjqFMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mima_01.png
// module id = mi43
// module chunks = 1